import { render, staticRenderFns } from "./RegistroParcial.vue?vue&type=template&id=213fca3d"
import script from "./RegistroParcial.vue?vue&type=script&lang=js"
export * from "./RegistroParcial.vue?vue&type=script&lang=js"
import style0 from "./RegistroParcial.vue?vue&type=style&index=0&id=213fca3d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports